import {shallowRef, computed} from 'vue';
import {useNavigationStore} from '@/stores/navigation';

export function useSearchInMenu() {
    const {menu: storeMenu} = useNavigationStore();
    const suggestions = shallowRef([]);

    const allowRenderSuggestions = computed(() => {
        return !!suggestions.value && !!suggestions.value.length;
    });

    const formattedSuggestions = computed(() => {
        return suggestions.value.map((suggestion) => {
            const pathTitle = suggestion.pathToPage.split('/').filter(Boolean).slice(0, 2).map((path) => {
                let result = '';
                for (let index = 0; index < storeMenu.length; index++) {
                    result = getPathTitleFromMenu(path, storeMenu[index]);
                    if (result) {
                        break;
                    }
                }

                return result;
            }).join(' / ');

            return {
                label: suggestion.title,
                pathToPage: suggestion.pathToPage,
                subLabel: pathTitle,
            };
        });
    });

    function getPathTitleFromMenu(searchValue, menuItem) {
        if (!menuItem.slug) {
            return;
        }

        if (menuItem?.slug === searchValue) {
            return menuItem.title;
        }

        if (!menuItem.subMenu) {
            return;
        }

        let result = '';

        for (let i = 0; i < menuItem.subMenu.length; i++) {
            result = getPathTitleFromMenu(searchValue, menuItem.subMenu[i]);
            if (result) {
                break;
            }
        }

        return result;
    }

    function searchInMenu(searchValue, menuItems) {
        const searchedPages = [];

        function setSearchResult(menu, searchString, path) {
            for (const menuItem of menu) {
                let currentPath = '';

                // TODO: refactor this or menu structure
                if (menuItem?.path && !menuItem?.slug) {
                    currentPath = menuItem?.path;
                } else if (menuItem?.isExternal || menuItem?.usePathWhenSearching) {
                    currentPath = menuItem?.path;
                } else if (menuItem?.slug) {
                    currentPath = `${path}/${menuItem.slug}`;
                } else {
                    currentPath = path;
                }

                if (menuItem.isActive && menuItem.title.toLowerCase().includes(searchString.toLowerCase())) {
                    searchedPages.push({
                        title: menuItem.title,
                        skip: !!menuItem.isExpanded,
                        pathToPage: currentPath,
                    });
                }
                if (menuItem?.subMenu) {
                    setSearchResult(menuItem.subMenu, searchString, currentPath);
                }
            }
        }

        setSearchResult(menuItems, searchValue, '');

        suggestions.value = searchedPages.reduce((acc, page) => {
            if (!acc.some((currentPage) => currentPage.pathToPage === page.pathToPage) && !page.skip) {
                acc.push(page);
            }

            return acc;
        }, []);
    }

    function resetSuggestions() {
        suggestions.value = [];
    }

    return {
        formattedSuggestions,
        allowRenderSuggestions,
        searchInMenu,
        menu: storeMenu,
        resetSuggestions,
    };
}
